// Copyright 2026. WebPros International GmbH. All rights reserved.

export const SET_HA_ACTIVITIES = 'high-availability/SET_HA_ACTIVITIES';
export const SET_HA_PROCESSES_FOR_ACTIVITY = 'high-availability/SET_HA_PROCESSES_FOR_ACTIVITY';
export const SET_HA_ACTIVITY_LOADING = 'high-availability/SET_HA_ACTIVITY_LOADING';
export const UNSET_HA_ACTIVITY_LOADING = 'high-availability/UNSET_HA_ACTIVITY_LOADING';
export const APPEND_HA_PROCESSES = 'high-availability/APPEND_HA_PROCESSES';
export const UPDATE_HA_PROCESS = 'high-availability/UPDATE_HA_PROCESS';
export const SET_HA_PROCESS_LOADING = 'high-availability/SET_HA_PROCESS_LOADING';
export const UNSET_HA_PROCESS_LOADING = 'high-availability/UNSET_HA_PROCESS_LOADING';
export const UPDATE_HA_ENTITY_TASK = 'high-availability/UPDATE_HA_TASK';
export const SET_HA_ENTITY_MOVE_BACK_PENDING = 'high-availability/SET_HA_ENTITY_MOVE_BACK_PENDING';
export const UNSET_HA_ENTITY_MOVE_BACK_PENDING = 'high-availability/UNSET_HA_ENTITY_MOVE_BACK_PENDING';
